<section [formGroup]="form()">
  @let controls = form().controls;
  <div class="tabs">
    <onyx-tabs
      [formControl]="controls.defaultType"
      [tabs]="invoiceTypes$ | async"
      label="labels.defaultInvoiceType"
      [size]="32"
    ></onyx-tabs>

    @let issueTermControl = controls.collectiveInvoiceIssueTerm;
    @if (issueTermControl.enabled) {
      <onyx-dropdown
        [formControl]="issueTermControl"
        label="labels.invoicing"
        [options]="collectiveInvoiceIssuesTerms$ | async"
        width="200px"
        [size]="32"
      ></onyx-dropdown>
    }

    @let selectedDayControl = controls.collectiveInvoiceIssueSelectedDay;
    @if (selectedDayControl.enabled) {
      <onyx-text-field
        [formControl]="selectedDayControl"
        label="labels.dayOfMonth"
        [decimalPlaces]="0"
        width="200px"
        [size]="32"
      ></onyx-text-field>
    }
  </div>

  @if (!isSelfBiling()) {
    <app-contractor-shipping-type-form
      [form]="controls.shippingType"
    ></app-contractor-shipping-type-form>

    <div class="dropdowns">
      <onyx-dropdown
        [formControl]="controls.primaryCurrency"
        label="labels.currency"
        [options]="currencies$ | async"
        [size]="32"
      ></onyx-dropdown>

      <onyx-form-group [controls]="controls.primaryLanguage">
        <onyx-dropdown
          [formControl]="controls.primaryLanguage"
          label="labels.language"
          [options]="languages$ | async"
          [search]="true"
          [showErrors]="false"
          [size]="32"
        ></onyx-dropdown>

        <onyx-suggestions
          [control]="controls.primaryLanguage"
          [suggestions]="languageSuggestions()"
        ></onyx-suggestions>
      </onyx-form-group>
    </div>
  }
</section>
